<template>
  <div class="user-unbind">
    <nav-bar
      fixed
      z-index="99"
      title="解约申请"
      left-text="返回"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div style="height: 46px"></div>

    <div class="form-wrapper">
      <div class="form-item">
        <div class="label">姓名</div>
        <div class="input">
          <input type="text" v-model="userInfo.signName" readonly />
        </div>
      </div>

      <div class="form-item">
        <div class="label">手机号</div>
        <div class="input">
          <input type="text" v-model="userInfo.signPhone" readonly />
        </div>
      </div>

      <div class="form-item">
        <div class="label">身份证</div>
        <div class="input">
          <input type="text" v-model="userInfo.cardId" readonly placeholder="请输入身份证号码" />
        </div>
      </div>

      <!-- 在解除绑定按钮上方添加解约说明 -->
      <div class="instruction-container" v-if="terminationStatement">
        <div class="instruction-title">解约说明</div>
        <div class="instruction-content" v-html="terminationStatement"></div>
      </div>

      <div class="unbind-btn" @click="showConfirmDialog">解除绑定</div>
    </div>
  </div>
</template>

<script>
import { getUserInfo, userUnbind } from "@/api/user";
import { getLcSystemConfig } from "@/api/public"; // 导入新的系统配置接口
import { NavBar, Dialog, Toast } from "vant";

export default {
  name: "UserUnbind",
  components: {
    NavBar
  },
  data() {
    return {
      userInfo: {
        realName: "",
        phone: "",
        cardId: ""
      },//初始化用户信息
      terminationStatement: "" // 存储解约说明内容
    };
  },
  mounted() {
    this.getUserData();
    this.getTerminationStatement();
  },
  methods: {
    // 获取用户信息
    getUserData() {
      getUserInfo().then(res => {
        if (res.status === 200) {
          // 保存完整的用户数据
          this.userInfo = {
            ...this.userInfo,
            ...res.data
          };
          console.log('获取用户信息成功:', this.userInfo);
        }
      }).catch(err => {
        Toast.fail("获取用户信息失败");
        console.error(err);
      });
    },

    // 获取解约说明内容
    getTerminationStatement() {
      getLcSystemConfig().then(res => {
        if (res.status === 200 && res.data && res.data.content) {
          const configData = res.data.content;
          // 查找解约说明配置项
          const terminationStatementConfig = configData.find(item => item.menuName === 'termination_statement');
          if (terminationStatementConfig) {
            this.terminationStatement = terminationStatementConfig.value;
          }
        }
      }).catch(error => {
        console.error('获取解约说明失败:', error);
      });
    },

    // 显示确认对话框
    showConfirmDialog() {
      if (!this.userInfo.cardId) {
        Toast.fail("请输入身份证号码");
        return;
      }

      Dialog.confirm({
        title: '解约确认',
        message: '确定要解除绑定吗？解约后将无法享受相关服务。',
      })
        .then(() => {
          this.submitUnbind();
        })
        .catch(() => {
          // 取消操作
        });
    },

    // 提交解约请求
    submitUnbind() {
      // 构造完整的解约数据结构，匹配后端API期望的格式
      const recruitData = {
        addIp: this.userInfo.addIp || "",
        addres: this.userInfo.addres || "",
        adminid: this.userInfo.adminid || 0,
        avatar: this.userInfo.avatar || "",
        birthday: this.userInfo.birthday || 0,
        brokeragePrice: 0.00,
        cardId: this.userInfo.cardId ||0,
        commentNumber: this.userInfo.commentNumber || 0,
        createTime: this.userInfo.createTime || "",
        email: this.userInfo.email || "",
        freeFirstNum: this.userInfo.freeFirstNum || 0,
        groupId: this.userInfo.groupId || 0,
        integral: 0.00,
        isFirst: this.userInfo.isFirst || 0,
        isPromoter: this.userInfo.isPromoter || 0,
        isSign: this.userInfo.isSign || 0,
        level: this.userInfo.level || 0,
        loginType: this.userInfo.loginType || "",
        mark: this.userInfo.mark || "",
        nickname: this.userInfo.nickname || "",
        nowMoney: 0.00,
        partnerId: this.userInfo.partnerId || 0,
        password: this.userInfo.password || "",
        payCount: this.userInfo.payCount || 0,
        payFirstNum: this.userInfo.payFirstNum || 0,
        payNum: this.userInfo.payNum || 0,
        phone: this.userInfo.phone || "",
        realName: this.userInfo.realName || "",
        signName: this.userInfo.signName,
        signNum: 0,
        signPhone: this.userInfo.signPhone,
        spreadCount: this.userInfo.spreadCount || 0,
        spreadTime: "",
        spreadUid: this.userInfo.spreadUid || 0,
        status: this.userInfo.status ? 1 : 0,
        totalConsumption: 0.00,
        uid: this.userInfo.uid || 0,
        userCategory: this.userInfo.userCategory || "",
        userType: this.userInfo.userType || "",
        username: this.userInfo.username || "",
        wechatNumber: this.userInfo.wechatNumber || "",
        welfareNum: this.userInfo.welfareNum || 0
      };

      console.log('发送解约请求数据:', recruitData);

      userUnbind(recruitData)
        .then(res => {
          console.log('解约请求响应:', res);
          if (res.status === 200) {
            Toast.success("解约成功");
            // 更新用户签约状态
            this.$store.commit('SET_USER', {...this.$store.state.app.userInfo, isSign: 0});
            // 返回上一页
            setTimeout(() => {
              this.$router.go(-1);
            }, 1500);
          } else {
            Toast.fail(res.message || "解约失败");
          }
        })
        .catch(err => {
          Toast.fail("解约请求失败");
          console.error('解约请求错误:', err);
        });
    }
  }
}
</script>

<style scoped>
.user-unbind {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.instruction-container {
  background-color: #fff;
  padding: 15px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.instruction-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}
.instruction-content {
  font-size: 14px;
  line-height: 1.5;
  color: #666;
}

.form-wrapper {
  padding: 20px;
  background-color: #fff;
  margin-top: 10px;
}

.form-item {
  margin-bottom: 15px;
}

.label {
  font-size: 0.28rem;
  color: #333;
  margin-bottom: 8px;
}

.input {
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

.input input {
  width: 100%;
  border: none;
  outline: none;
  font-size: 0.28rem;
  color: #333;
}

input:disabled {
  background-color: transparent;
  color: #999;
}

.unbind-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #ee0a24;
  color: #fff;
  border-radius: 20px;
  margin-top: 30px;
  font-size: 0.28rem;
}

.unbind-btn:active {
  opacity: 0.8;
}
</style>
